<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">QUITAR DISPOSITIVO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div class="del_ctn">
                      <p>¿Esta seguro que desea quitar este dispositivo?</p>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn class="btn_delete" depressed large @click="validate"
                  >Quitar</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "NetworkDeviceDelComp",
  components: {},
  props: {
    visible: {
      type: Boolean,
    },
    IdIntegrator: {
      type: String,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      valid: true,
      name: null,
      nameRules: {
        required: (v) => !!v || "El campo es requerido",
        equal: (v) =>
          v === this.data.name || "El nombre del integrador no coincide.",
      },
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
  },
  methods: {
    ...mapActions([
      "deleteDeviceIntegrator",
      "alertSnackbar",
      "QueryIntegrator",
    ]),
    validate() {
      this.registerForm();
    },
    async registerForm() {
      try {
        let form = {
          _idIntegrator: this.IdIntegrator,
          _idDevice: this.data._id,
          device: this.data.device._id,
        };
        let update = await this.deleteDeviceIntegrator(form);
        this.$refs.form.reset();
        if (update == 200) {
          this.show = false;
          this.alertSnackbar({
            snackbar: true,
            text: "El integrador se ha borrado.",
          });
          await this.QueryIntegrator(this.IdIntegrator);
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/base.scss";
.del_ctn {
  p {
    font-family: Roboto;
    font-size: 1rem;
    margin-bottom: 0;
  }
}
</style>
